namespace $.$$ {

	export class $shm_wordstat_task_catalog extends $.$shm_wordstat_task_catalog {

		filter_text( value: string ) {
			return String( value ).replaceAll( '\\', '\\\\' ).replaceAll( '"', '\\"' )
		}

		user_id() {
			return this.$.$shm_ba_pb.user_id()
		}

		stats_revision() {
			return this.task_records()
				.map( task => [ task.id, task.updated, task.regular_daily, task.collect_total ].join( ':' ) )
				.join( '|' ) || 'empty'
		}

		stats_data() {
			const revision = encodeURIComponent( this.stats_revision() )
			const response = this.$.$mol_fetch.response( `${ this.$.$shm_ba_pb.url() }/api/hitalama/wordstat/stats?revision=${ revision }`, {
				headers: this.$.$shm_ba_pb.user_headers(),
			} )
			if( !response.ok() ) throw new Error( response.message() )
			return response.json() as { tasks?: number, items?: number, requests?: number }
		}

		regular_tasks() { return String( this.stats_data().tasks || 0 ) }
		regular_items() { return String( this.stats_data().items || 0 ) }
		daily_requests() { return String( this.stats_data().requests || 0 ) }

		task_records() {
			const user = this.user_id()
			if( !user ) return [] as readonly $shm_pocketbase_record[]
			return this.$.$shm_ba_pb.records_page_realtime_live(
				`wordstat_tasks\nuser = "${ this.filter_text( user ) }"\n-sort,title\n1\n200\nid,user,title,sort,settings,collect_total,regular_daily,updated`,
				`wordstat_tasks/user:${ user }:catalog`,
				record => String( record.user || '' ) === user,
			)
		}

		task_items() {
			const user = this.user_id()
			if( !user ) return [] as readonly $shm_pocketbase_record[]
			const task_ids = new Set( this.task_records().map( task => task.id ) )
			const result: $shm_pocketbase_record[] = []
			for( let page = 1; page <= 1000; ++page ) {
				const chunk = this.$.$shm_ba_pb.records_page_realtime(
					`wordstat_task_items\ntask.user = "${ this.filter_text( user ) }" && period = "PERIOD_DAILY" && result_stored = true && row_count > 0\ndate_from,id\n${ page }\n500\nid,task,date_from,row_count`,
				)
				result.push( ...chunk.filter( item => task_ids.has( String( item.task || '' ) ) ) )
				if( chunk.length < 500 ) break
			}
			return result
		}

		task_record( id: string ) {
			return this.task_records().find( task => task.id === id ) ?? null
		}

		tasks_filtered() {
			const query = this.filter().trim().toLowerCase()
			if( !query ) return this.task_records()
			return this.task_records().filter( task => String( task.title || '' ).toLowerCase().includes( query ) )
		}

		task_rows() {
			const tasks = this.tasks_filtered()
			return tasks.length ? tasks.map( task => this.Task( task.id ) ) : [ this.Empty() ]
		}

		task_title( id: string ) {
			return String( this.task_record( id )?.title || id )
		}

		task_queries( id: string ) {
			const settings = this.task_record( id )?.settings as { queries?: string } | undefined
			return [ ...new Set( String( settings?.queries || '' ).split( /\r?\n/ ).map( value => value.trim() ).filter( Boolean ) ) ].join( ', ' ) || '—'
		}

		task_subtasks( id: string ) {
			return Number( this.task_record( id )?.collect_total || 0 ).toLocaleString( 'ru-RU' )
		}

		task_date( id: string ) {
			const dates = this.task_items()
				.filter( item => String( item.task || '' ) === id )
				.map( item => String( item.date_from || '' ).slice( 0, 10 ) )
				.filter( Boolean )
				.sort()
			if( !dates.length ) return '—'
			const [ year, month, day ] = dates[0].split( '-' )
			return year && month && day ? `${ day }.${ month }.${ year }` : dates[0]
		}

		task_daily( id: string, next?: boolean ) {
			const task = this.task_record( id )
			if( next === undefined ) return Boolean( task?.regular_daily )
			if( task?.id ) this.$.$shm_ba_pb.update_record( 'wordstat_tasks', id, { regular_daily: next } )
			return next
		}

		task_arg( id: string ) {
			return {
				section: 'wordstat',
				wordstat_task: id,
				wordstat_mode: null,
				wordstat_filter_id: this.task_filter_id( id ),
				dashboard: null,
				report: null,
				ba_filter_id: null,
			}
		}

		task_filter_id( id: string ) {
			return this.$.$mol_state_local.value< string >( `hitalama_wordstat_filter_last:${ id }` ) || null
		}

		task_uri( id: string ) {
			return new this.$.$mol_state_arg( this.Task_title( id ).state_key() ).link( this.task_arg( id ) )
		}

	}

}
